(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["invisoutlet-pro-cro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const form = root.querySelector('[data-iop-form]');
      const quantityInput = root.querySelector('[data-iop-quantity]');
      const propertyInput = root.querySelector('[data-iop-property]');
      const status = root.querySelector('[data-iop-form-status]');
      const textTemplate = root.querySelector('[data-iop-text]');
      const addingText = textTemplate?.content.querySelector('[data-adding]')?.textContent?.trim() || '';
      const addedText = textTemplate?.content.querySelector('[data-added]')?.textContent?.trim() || '';
      const errorText = textTemplate?.content.querySelector('[data-error]')?.textContent?.trim() || '';
      const unitSingular = textTemplate?.content.querySelector('[data-unit-singular]')?.textContent?.trim() || 'outlet';
      const unitPlural = textTemplate?.content.querySelector('[data-unit-plural]')?.textContent?.trim() || 'outlets';
      const ctaTemplate = textTemplate?.content.querySelector('[data-cta-template]')?.textContent?.trim() || '';
      const discountTemplate = textTemplate?.content.querySelector('[data-discount-template]')?.textContent?.trim() || '';
      const standardTemplate = textTemplate?.content.querySelector('[data-standard-template]')?.textContent?.trim() || '';
      const stickyDiscountTemplate = textTemplate?.content.querySelector('[data-sticky-discount-template]')?.textContent?.trim() || discountTemplate;
      const stickyStandardTemplate = textTemplate?.content.querySelector('[data-sticky-standard-template]')?.textContent?.trim() || standardTemplate;
      const msrpTemplate = textTemplate?.content.querySelector('[data-msrp-template]')?.textContent?.trim() || '';
      const propertyTemplate = textTemplate?.content.querySelector('[data-property-template]')?.textContent?.trim() || '';
      const redirectAfterAdd = root.dataset.redirectAfterAdd === 'true';
      const unitPrices = {
        one: Number(root.dataset.oneUnit || 0),
        two: Number(root.dataset.twoUnit || 0),
        four: Number(root.dataset.fourUnit || 0),
        six: Number(root.dataset.sixUnit || 0)
      };
      const msrpUnit = Number(root.dataset.msrpUnit || unitPrices.one);
      const moneyLocale = document.documentElement.lang || 'en';
      const moneyCurrency = root.dataset.currency || 'USD';
      const formatMoney = (cents) => {
        const amount = Math.max(0, cents);
        const fractionDigits = amount % 100 === 0 ? 0 : 2;
        return new Intl.NumberFormat(moneyLocale, {
          style: 'currency',
          currency: moneyCurrency,
          minimumFractionDigits: fractionDigits,
          maximumFractionDigits: 2
        }).format(amount / 100);
      };
      const interpolate = (template, values) => Object.entries(values).reduce((output, [key, value]) => output.split(`[${key}]`).join(String(value)), template);
      const tierForQuantity = (quantity) => {
        if (quantity >= 6) return 'six';
        if (quantity >= 4) return 'four';
        if (quantity >= 2) return 'two';
        return 'one';
      };
      let currentQuantity = Math.max(1, Math.floor(Number(root.dataset.defaultQuantity || 1)));
      let currentTier = tierForQuantity(currentQuantity);
      let currentTotal = currentQuantity * unitPrices[currentTier];

      const mobileSticky = root.querySelector('[data-iop-sticky]');
      const heroPurchase = root.querySelector('.iop-purchase');
      const finalOffer = root.querySelector('.iop-final__box');
      const toast = root.querySelector('[data-iop-toast]');
      const toastMessage = root.querySelector('[data-iop-toast-message]');
      const toastClose = root.querySelector('[data-iop-toast-close]');
      let toastTimer;
      const hideToast = () => {
        if (!toast) return;
        toast.classList.remove('is-visible');
        toast.setAttribute('aria-hidden', 'true');
      };
      const showToast = (message, isError = false) => {
        if (!toast || !toastMessage) return;
        window.clearTimeout(toastTimer);
        toastMessage.textContent = message;
        toast.classList.toggle('is-error', isError);
        toast.classList.add('is-visible');
        toast.setAttribute('aria-hidden', 'false');
        toastTimer = window.setTimeout(hideToast, 5000);
      };
      toastClose?.addEventListener('click', hideToast);
      if (mobileSticky && heroPurchase && finalOffer) {
        let heroVisible = true;
        let finalVisible = false;
        const syncSticky = () => {
          const visible = !heroVisible && !finalVisible;
          mobileSticky.classList.toggle('is-visible', visible);
          mobileSticky.setAttribute('aria-hidden', String(!visible));
        };
        if ('IntersectionObserver' in window) {
          const stickyObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.target === heroPurchase) heroVisible = entry.isIntersecting;
              if (entry.target === finalOffer) finalVisible = entry.isIntersecting;
            });
            syncSticky();
          }, { threshold: 0.08 });
          stickyObserver.observe(heroPurchase);
          stickyObserver.observe(finalOffer);
          syncSticky();
        } else {
          mobileSticky.classList.add('is-visible');
          mobileSticky.setAttribute('aria-hidden', 'false');
        }
      }

      const emit = (name, detail) => {
        window.dispatchEvent(new CustomEvent(name, { detail }));
        if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...detail });
      };

      const commerceDetail = (quantity, unitPrice) => {
        const sku = root.dataset.variantSku || root.dataset.variantId || '';
        const currency = root.dataset.currency || 'USD';
        const value = (quantity * unitPrice) / 100;
        return {
          productId: root.dataset.productId || '',
          variantId: root.dataset.variantId || '',
          sku,
          productTitle: root.dataset.productTitle || '',
          productHandle: root.dataset.productHandle || '',
          productVendor: root.dataset.productVendor || '',
          variantTitle: root.dataset.variantTitle || '',
          unitPrice: unitPrice / 100,
          content_type: 'product',
          content_ids: [sku],
          contents: [{ id: sku, quantity, item_price: unitPrice / 100 }],
          ecommerce: {
            currency,
            value,
            items: [{
              item_id: sku,
              item_name: root.dataset.productTitle || '',
              item_brand: root.dataset.productVendor || '',
              item_variant: root.dataset.variantTitle || root.dataset.variantId || '',
              price: unitPrice / 100,
              quantity
            }]
          }
        };
      };

      const syncQuantity = (nextQuantity, shouldEmit = true) => {
        const quantity = Math.max(1, Math.floor(Number(nextQuantity || 1)));
        const tier = tierForQuantity(quantity);
        const unitPrice = unitPrices[tier];
        const total = quantity * unitPrice;
        const discount = unitPrices.one > 0 ? Math.round(Math.max(0, ((unitPrices.one - unitPrice) / unitPrices.one) * 100)) : 0;
        const unitWord = quantity === 1 ? unitSingular : unitPlural;
        const price = formatMoney(total);
        const msrpPrice = formatMoney(msrpUnit);
        const unitPriceText = formatMoney(unitPrice);
        const label = discount > 0
          ? interpolate(discountTemplate, { count: quantity, unit_word: unitWord, discount })
          : interpolate(standardTemplate, { count: quantity, unit_word: unitWord });
        const stickyLabel = discount > 0
          ? interpolate(stickyDiscountTemplate, { count: quantity, unit_word: unitWord, discount })
          : interpolate(stickyStandardTemplate, { count: quantity, unit_word: unitWord });
        const cta = interpolate(ctaTemplate, { count: quantity, unit_word: unitWord, price });
        const property = interpolate(propertyTemplate, { count: quantity, unit_word: unitWord, price: unitPriceText });
        currentQuantity = quantity;
        currentTier = tier;
        currentTotal = total;
        root.dataset.currentTier = tier;
        root.dataset.currentQuantity = String(quantity);

        root.querySelectorAll('[data-iop-quantity-field]').forEach((node) => { node.value = String(quantity); });
        root.querySelectorAll('[data-iop-compare-unit]').forEach((node) => {
          node.textContent = interpolate(msrpTemplate, { price: msrpPrice });
          node.hidden = msrpUnit <= unitPrice;
        });
        root.querySelectorAll('[data-iop-coverage]').forEach((node) => { node.textContent = label; });
        root.querySelectorAll('[data-iop-label]').forEach((node) => { node.textContent = label; });
        root.querySelectorAll('[data-iop-sticky-label]').forEach((node) => { node.textContent = stickyLabel; });
        if (root.dataset.available === 'true') root.querySelectorAll('[data-iop-cta]').forEach((node) => { node.textContent = cta; });
        root.querySelectorAll('[data-quantity-change]').forEach((button) => {
          const delta = Number(button.dataset.quantityChange || 0);
          button.disabled = quantity === 1 && delta < 0;
        });
        if (quantityInput) quantityInput.value = String(quantity);
        if (propertyInput) propertyInput.value = property;

        if (shouldEmit) {
          emit('lp:bundle-change', {
            pack: tier,
            tier,
            quantity,
            value: total / 100,
            currency: root.dataset.currency,
            ...commerceDetail(quantity, unitPrice)
          });
        }
      };

      root.querySelectorAll('[data-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => syncQuantity(currentQuantity + Number(button.dataset.quantityChange || 0)));
      });
      root.querySelectorAll('[data-iop-quantity-field]').forEach((field) => {
        field.addEventListener('input', () => {
          if (field.value === '') return;
          const quantity = Math.floor(Number(field.value));
          if (Number.isFinite(quantity) && quantity >= 1) syncQuantity(quantity);
        });
        field.addEventListener('change', () => syncQuantity(field.value));
      });
      syncQuantity(currentQuantity, false);

      const reviewTrack = root.querySelector('[data-review-track]');
      const reviewSlides = Array.from(root.querySelectorAll('[data-review-slide]'));
      const reviewPrevious = root.querySelector('[data-review-previous]');
      const reviewNext = root.querySelector('[data-review-next]');
      const reviewCurrent = root.querySelector('[data-review-current]');
      const reviewTotal = root.querySelector('[data-review-total]');
      let activeReview = 0;
      let reviewFrame;
      const reviewOffset = (slide) => slide.offsetLeft - reviewTrack.offsetLeft;
      const updateReviewPosition = () => {
        if (!reviewTrack || reviewSlides.length === 0) return;
        activeReview = reviewSlides.reduce((closestIndex, slide, index) => (
          Math.abs(reviewOffset(slide) - reviewTrack.scrollLeft) < Math.abs(reviewOffset(reviewSlides[closestIndex]) - reviewTrack.scrollLeft)
            ? index
            : closestIndex
        ), 0);
        if (reviewCurrent) reviewCurrent.textContent = String(activeReview + 1);
        if (reviewTotal) reviewTotal.textContent = String(reviewSlides.length);
        if (reviewPrevious) reviewPrevious.disabled = activeReview === 0;
        if (reviewNext) reviewNext.disabled = activeReview === reviewSlides.length - 1;
      };
      const goToReview = (index) => {
        if (!reviewTrack || reviewSlides.length === 0) return;
        const nextIndex = Math.min(reviewSlides.length - 1, Math.max(0, index));
        reviewTrack.scrollTo({
          left: reviewOffset(reviewSlides[nextIndex]),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      reviewPrevious?.addEventListener('click', () => goToReview(activeReview - 1));
      reviewNext?.addEventListener('click', () => goToReview(activeReview + 1));
      reviewTrack?.addEventListener('scroll', () => {
        window.cancelAnimationFrame(reviewFrame);
        reviewFrame = window.requestAnimationFrame(updateReviewPosition);
      }, { passive: true });
      window.addEventListener('resize', updateReviewPosition, { passive: true });
      updateReviewPosition();

      const ecosystemTabs = Array.from(root.querySelectorAll('[data-ecosystem-tab]'));
      const activateEcosystem = (tab, moveFocus = false) => {
        if (!tab) return;
        const ecosystem = tab.dataset.ecosystemTab;
        ecosystemTabs.forEach((candidate) => {
          const active = candidate === tab;
          candidate.setAttribute('aria-selected', String(active));
          candidate.tabIndex = active ? 0 : -1;
        });
        root.querySelectorAll('[data-ecosystem-panel]').forEach((panel) => { panel.hidden = panel.dataset.ecosystemPanel !== ecosystem; });
        if (moveFocus || window.matchMedia('(max-width: 640px)').matches) {
          tab.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        }
        if (moveFocus) tab.focus();
      };
      ecosystemTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateEcosystem(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % ecosystemTabs.length;
          else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + ecosystemTabs.length) % ecosystemTabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = ecosystemTabs.length - 1;
          else return;
          event.preventDefault();
          activateEcosystem(ecosystemTabs[nextIndex], true);
        });
      });

      root.querySelectorAll('[data-iop-external-submit]').forEach((button) => {
        button.addEventListener('click', () => {
          root.dataset.submitLocation = button.dataset.location || 'unknown';
          root.dataset.submitQuantity = button.dataset.fixedQuantity || '';
          form?.requestSubmit();
        });
      });

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!form) return;
        const submitter = event.submitter;
        const location = root.dataset.submitLocation || submitter?.dataset.location || 'hero';
        const requestedQuantity = Number(root.dataset.submitQuantity || currentQuantity);
        root.dataset.submitLocation = '';
        root.dataset.submitQuantity = '';
        const quantity = Math.max(1, Math.floor(requestedQuantity || 1));
        const purchaseTier = tierForQuantity(quantity);
        const total = quantity * unitPrices[purchaseTier];
        const unitPrice = unitPrices[purchaseTier];
        const purchaseProperty = interpolate(propertyTemplate, {
          count: quantity,
          unit_word: quantity === 1 ? unitSingular : unitPlural,
          price: formatMoney(unitPrice)
        });

        emit('lp:add-to-cart-intent', {
          pack: purchaseTier,
          tier: purchaseTier,
          quantity,
          value: total / 100,
          currency: root.dataset.currency,
          location,
          ...commerceDetail(quantity, unitPrice)
        });

        root.querySelectorAll('[data-iop-submit], [data-iop-external-submit]').forEach((button) => {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        });
        root.querySelectorAll('[data-iop-cta]').forEach((node) => { node.textContent = addingText; });
        if (status) status.textContent = addingText;

        try {
          if (quantityInput) quantityInput.value = String(quantity);
          const formData = new FormData(form);
          formData.set('id', root.dataset.variantId || '');
          formData.set('quantity', String(quantity));
          if (propertyInput?.name) formData.set(propertyInput.name, purchaseProperty);
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
            body: formData
          });
          const responseType = response.headers.get('content-type') || '';
          const result = responseType.includes('application/json') ? await response.json() : {};
          if (!response.ok || result.status) throw new Error(result.description || result.message || errorText);

          emit('lp:add-to-cart', {
            pack: purchaseTier,
            tier: purchaseTier,
            quantity,
            value: total / 100,
            currency: root.dataset.currency,
            location,
            ...commerceDetail(quantity, unitPrice)
          });
          if (status) status.textContent = addedText;
          showToast(addedText);

          if (redirectAfterAdd) {
            window.location.assign(root.dataset.cartUrl);
            return;
          }

          const cartStateResponse = await fetch(`${root.dataset.cartUrl}.js`, {
            headers: { Accept: 'application/json' }
          }).catch(() => null);
          if (cartStateResponse?.ok) {
            const cartState = await cartStateResponse.json();
            const itemCount = Number(cartState.item_count || 0);
            const cartLink = root.querySelector('[data-iop-cart-link]');
            const countNode = cartLink?.querySelector('span');
            if (countNode) countNode.textContent = String(itemCount);
            if (cartLink && root.dataset.cartCountLabel) {
              cartLink.setAttribute('aria-label', root.dataset.cartCountLabel.replace('[count]', String(itemCount)));
            }
          }
        } catch (error) {
          const message = error instanceof Error ? error.message : errorText;
          if (status) status.textContent = message;
          showToast(message, true);
        } finally {
          root.querySelectorAll('[data-iop-submit], [data-iop-external-submit]').forEach((button) => {
            button.disabled = root.dataset.available !== 'true';
            button.removeAttribute('aria-busy');
          });
          syncQuantity(currentQuantity, false);
        }
      });
    };

    document.querySelectorAll('[data-iop-cro]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-iop-cro]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
